<template>
    <b-modal
        :id="`modal-service-distribution_${modalKey}`"
        :ref="`distributionModal_${modalKey}`"
        title="Распределите исполнителей"
        @shown="onShowModal"
        @hidden="onCloseModal"
        hide-footer
        size="lg"
    >
        <div class="position-relative pt-2 pb-4">
            <div class="row mt-3 mb-3" v-for="(service, index) in services" :key="service.id">
                <div class="col-md-3 service-name-in-distribution align-self-center text-right">{{ service.reference.name }}</div>
                <div class="col-md-6">
                    <div 
                        class="active-panel-block-select-user-wrapper"
                        style="width: 100%;"
                    >
                        <tsoft-select-user
                            :key="`order-service-manager-distribution-${index}`"
                            :id="`order-service-manager-distribution-${index}`"
                            :roles="`logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||bsz-manager||b2c-head-manager||b2c-manager`"
                            :needNullElement="true"
                            :needMultipleSelect="true"
                            :needOnlyOneFromDepartment="true"
                            :selectedArray="getSelectedUserIds(index)"
                            :additionalParameter="index"
                            @set="setManagerOfService"
                        ></tsoft-select-user>
                    </div>
                </div>
                <div class="col-md-2 align-self-center">
                    <b-button size="sm"
                              :variant="(service.users.length > 0 && checkSimilar(index)) ? 'secondary' : 'primary'"
                              :disabled="!service.isUserSelected"
                              @click="saveDistributionOfUser(index)"
                    >
                        Назначить
                    </b-button>
                </div>
            </div>
            <b-overlay
                :show="modalOverlay"
                spinner-variant="success"
                no-wrap
            ></b-overlay>
        </div>
    </b-modal>
</template>

<script>
import { API_GET_SERVICES_BY_ORDERS, API_ORDERS_SERVICE } from '../../constants';

export default {
    props: {
        isOpenServiceDistributionModal: { type: Boolean, required: true },
        editedItem: { type: Object, required: true },
        modalKey: { type: String, required: false, default: '' },
    },
    data() {
        return {
            services: [],
            modalOverlay: true,
        };
    },
    watch: {
        isOpenServiceDistributionModalLocal: {
            immediate: false,
            handler(value) {
                if (value) {
                    this.$bvModal.show(`modal-service-distribution_${this.modalKey}`);
                } else {
                    this.$bvModal.hide(`modal-service-distribution_${this.modalKey}`);
                    this.$emit('updateOneOrder', -1, this.editedItem.id);
                }
            },
        },
    },
    computed: {
        isOpenServiceDistributionModalLocal: {
            get() {
                return this.isOpenServiceDistributionModal;
            },
            set(value) {
                this.$emit('update:isOpenServiceDistributionModal', value);
            },
        },
    },
    methods: {
        // Define the missing onShowModal and onCloseModal methods
        onShowModal() {
            this.getDataHandler();
        },
        onCloseModal() {
            this.modalOverlay = true;
            this.services = [];
            this.isOpenServiceDistributionModalLocal = false;
        },
        async getDataHandler() {
            let order_id = this.editedItem.id;
            const response = await api.call('get', API_GET_SERVICES_BY_ORDERS + `/${order_id}`);
            this.services = response.data;
            this.services.forEach((service, index) => {
                // Initialize selectedUsers with existing user IDs
                const existingUserIds = service.users.map((user) => user.id);
                this.$set(this.services[index], 'selectedUsers', existingUserIds); // Initialize selectedUsers
                this.$set(this.services[index], 'isUserSelected', false);
            });

            this.modalOverlay = false;
        },
        setManagerOfService(value, index) {
            if (!this.services[index]) {
                console.error(`Service at index ${index} is undefined.`);
                return;
            }

            const currentSelectedIds = this.services[index].selectedUsers || [];
            const newSelectedIds = Array.isArray(value) ? value : [];

            if (!this.equalsIgnoreOrder(currentSelectedIds, newSelectedIds)) {
                this.services[index].selectedUsers = newSelectedIds;
                this.services[index].isUserSelected = true;
                this.checkSimilar(index);
            }
        },
        getSelectedUserIds(index) {
            // Always return selectedUsers, even if empty, to avoid re-initialization
            if (this.services[index] && this.services[index].selectedUsers) {
                return this.services[index].selectedUsers;
            }
            return [];
        },
        saveDistributionOfUser(index) {
            this.modalOverlay = true;
            this.services[index].isUserSelected = false;
            api
                .call('post', API_ORDERS_SERVICE + `/${this.services[index].id}/users`, {
                    selected_user: this.services[index].selectedUsers,
                })
                .then(({ data }) => {
                    this.services[index].isUserSelected = false;
                    this.services[index].users = data; // Update users after save
                    this.checkSimilar(index, true);
                })
                .finally(() => {
                    this.modalOverlay = false;
                });
        },
        equalsIgnoreOrder(a, b) {
            if (a.length !== b.length) return false;
            const uniqueValues = new Set([...a, ...b]);
            for (const v of uniqueValues) {
                const aCount = a.filter((e) => e === v).length;
                const bCount = b.filter((e) => e === v).length;
                if (aCount !== bCount) return false;
            }
            return true;
        },
        checkSimilar(index, forcedCheck = false) {
            if (this.services[index].isUserSelected || forcedCheck) {
                let nowSelectedUsersIds = this.services[index].selectedUsers.slice();
                let earlySelectedUsers = this.services[index].users.map((user) => user.id);

                nowSelectedUsersIds.sort();
                earlySelectedUsers.sort();

                if (nowSelectedUsersIds.toString() === earlySelectedUsers.toString()) {
                    return true;
                }
            }

            return false;
        },
    },
};
</script>
